import React from 'react'
import { Login } from '../components/login'
export const HomeScreen = () => {
  return (
    <>
      <Login />
    </>
  )
}
